"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var d3_force_1 = require("d3-force");

var abstract_1 = require("../abstract");

var PackingPlugin =
/*#__PURE__*/
function (_abstract_1$Constrain) {
  _inherits(PackingPlugin, _abstract_1$Constrain);

  function PackingPlugin(solver, cx, cy, points, axisOnly, getXYScale) {
    var _this;

    _classCallCheck(this, PackingPlugin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PackingPlugin).call(this));
    _this.solver = solver;
    _this.cx = cx;
    _this.cy = cy;
    _this.points = points;
    _this.xEnable = axisOnly == null || axisOnly == "x";
    _this.yEnable = axisOnly == null || axisOnly == "y";
    _this.getXYScale = getXYScale;
    return _this;
  }

  _createClass(PackingPlugin, [{
    key: "apply",
    value: function apply() {
      var _this2 = this;

      var xScale = 1;
      var yScale = 1;

      if (this.getXYScale != null) {
        var _this$getXYScale = this.getXYScale(),
            x = _this$getXYScale.x,
            y = _this$getXYScale.y;

        xScale = x;
        yScale = y;
      }

      var cx = this.solver.getValue(this.cx);
      var cy = this.solver.getValue(this.cy);
      var nodes = this.points.map(function (pt) {
        var x = (_this2.solver.getValue(pt[0]) - cx) / xScale;
        var y = (_this2.solver.getValue(pt[1]) - cy) / yScale; // Use forceSimulation's default initialization

        return {
          fx: !_this2.xEnable ? x : undefined,
          fy: !_this2.yEnable ? y : undefined,
          r: pt[2]
        };
      });
      var force = d3_force_1.forceSimulation(nodes);
      force.force("collision", d3_force_1.forceCollide(function (d) {
        return d.r;
      }));
      force.force("gravityX", d3_force_1.forceX().strength(0.1));
      force.force("gravityY", d3_force_1.forceY().strength(0.1));
      force.stop();
      var n = Math.ceil(Math.log(force.alphaMin()) / Math.log(1 - force.alphaDecay()));

      for (var i = 0; i < n * 2; i++) {
        force.tick();
      }

      for (var _i = 0; _i < nodes.length; _i++) {
        if (this.xEnable) {
          this.solver.setValue(this.points[_i][0], nodes[_i].x * xScale + cx);
        }

        if (this.yEnable) {
          this.solver.setValue(this.points[_i][1], nodes[_i].y * yScale + cy);
        }
      }

      return true;
    }
  }]);

  return PackingPlugin;
}(abstract_1.ConstraintPlugin);

exports.PackingPlugin = PackingPlugin;